'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * A React hook for getting an elements height and width, changing when resized.
 * @param UseElementResizeOptions
 * @returns UseElementResizeState
 */ const useElementSize = ({ enabled , ref  })=>{
    const [size, setSize] = React.useState({
        height: 0,
        width: 0
    });
    React.useEffect(()=>{
        if (!enabled || !ref?.current) return;
        const resizeObserver = new ResizeObserver((e)=>{
            setSize({
                height: e[0].contentRect.height,
                width: e[0].contentRect.width
            });
        });
        resizeObserver.observe(ref.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        enabled,
        ref
    ]);
    return size;
};

exports.useElementSize = useElementSize;
//# sourceMappingURL=use-element-size.js.map
